// Classes.
import {BaseLocator} from './../locators/base.locator';
import {AthleteLocatorComponent} from './../locators/athlete.locator-component';
import {LevelLocatorComponent} from './../locators/level.locator-component';
import {DateLocatorComponent} from './../locators/date.locator-component';
import {DisciplineLocatorComponent} from './../locators/discipline.locator-component';


export class AthleteResultListLocator extends BaseLocator {

  public athlete: AthleteLocatorComponent;
  public level: LevelLocatorComponent;
  public discipline: DisciplineLocatorComponent;
  public startDate: DateLocatorComponent;
  public endDate: DateLocatorComponent;

  constructor() {
    super('athleteResultList');
    this.addComponentByType('athlete');
    this.addComponentByType('level', 'level');
    this.addComponentByType('discipline', 'discipline');
    this.addComponentByType('date', 'startDate');
    this.addComponentByType('date', 'endDate');
  }
}

